import * as echarts from 'echarts/core';

export const chartColorArr = [
  '#3264FF',
  '#FF963C',
  '#6FC61F',
  '#E23636',
  '#914EE3',
]

export const chartLinearGradientArr = [
  ['#61DAFF', '#3264FF'],
  ['#FFCE6F', '#FF963C'],
  ['#AAD84A', '#6FC61F'],
  ['#ED6969', '#E23636'],
  ['#A51FFF', '#914EE3'],
]

export const createLinearGradient = (inx) => {
  let index = inx > 4 ? 4 : inx;
  
  return new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
    offset: 0,
    color: chartLinearGradientArr[index][0]
  }, {
    offset: 1,
    color: chartLinearGradientArr[index][1]
  }], false)
}

export const createLinearGradientColumn = (inx) => {
  let index = inx > 4 ? 4 : inx;
  
  return new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
    offset: 0,
    color: chartLinearGradientArr[index][0]
  }, {
    offset: 1,
    color: chartLinearGradientArr[index][1]
  }], false)
}
